import { createContext, useContext } from "react";
import { SurveyCheckResult } from "../../types/syncCheckResult";

export const surveyCheckResultContext = createContext<SurveyCheckResult | null>(null);

export function useSurveyCheckResultContext() {
  const context = useContext(surveyCheckResultContext);
  if (!context) {
    throw new Error("useSurveyCheckResultContext must be used within a SurveyCheckResultProvider");
  }
  return context;
}